import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {AnalysisRightSidebarItemType} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisRightSidebarItem} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';

export function getAncestorStepsByType(
  analysis: PipelineGraphQL,
  step: GetAnalysisPipelineStep,
  stepType: PipelineStepType
): Array<GetAnalysisPipelineStep> {
  return getTableLineageAncestorSteps(analysis, step).filter((step) => step.definition.stepType === stepType);
}

export interface RightSidebarItemState {
  onChangeSelectedRightSidebarItem: (item: AnalysisRightSidebarItem | null) => void;
  selectedRightSidebarItem: AnalysisRightSidebarItem | null;
}

export function updateRightSidebarItemOnAddingStep(
  newStep: GetAnalysisPipelineStep,
  rightSidebarItemState: RightSidebarItemState
): void {
  if (rightSidebarItemState.selectedRightSidebarItem == null) {
    return;
  }

  if (rightSidebarItemState.selectedRightSidebarItem.type === AnalysisRightSidebarItemType.EDIT_VIEW) {
    rightSidebarItemState.onChangeSelectedRightSidebarItem({
      type: AnalysisRightSidebarItemType.EDIT_VIEW,
      viewReference: {
        stepId: newStep.id,
        outputReference: {
          stepDataName: newStep.outputStepDatas[0].name,
          rawDataIndex: 0,
        },
      },
    });
  }
}

export function setRightSidebarItemIsUpdating(rightSidebarItemState: RightSidebarItemState): void {
  if (rightSidebarItemState.selectedRightSidebarItem?.type === AnalysisRightSidebarItemType.EDIT_VIEW) {
    rightSidebarItemState.onChangeSelectedRightSidebarItem({
      ...rightSidebarItemState.selectedRightSidebarItem,
      isUpdating: true,
    });
  }
}
